/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */

'use strict';

var shippingAddressUpdate = require('./shippingAddressUpdate');

// Access Point address autocompleter.
var apSwiper = null;
var apMap = null;
var apMarkers = [];
var apCurrentInfo = null;
var apLastMapResults = null;
var $shipping = $('.shipping-content');
var attrCurrentLocation = 'current-location';
var searchAddress = '.field-ap-search-address';

/**
 * Add marker
 * @param {obj} marker - current marker obj
 */
var addMarker = function (marker) {
    apMarkers.push(marker);
};

/**
 * Clear marker
 */
var clearMarkers = function () {
    // eslint-disable-next-line no-plusplus
    for (var i = 0, e = apMarkers.length; i < e; i++) {
        apMarkers[i].setMap(null);
    }
    apMarkers = [];
};

/**
 * Setting marker icon
 * @param {obj} marker - current marker obj
 * @param {string} icon - map icon
 */
var setMarkerIcon = function (marker, icon) {
    if (icon) {
        marker.setIcon({
            url: icon,
            anchor: new google.maps.Point(4, 34)
        });
    }
};

/**
 * Ajax Call for getting the location
 */
var searchForAccessPoint = function () {
    // Hide validation messages.
    $shipping.find('.access-points-required').hide();

    var $input = $shipping.find(searchAddress);

    var lat = $input.data('lat');
    var lng = $input.data('lng');

    var continueSearch = function (searchlat, searchlng) {
        var countryCode = $shipping.find('.shippingCountry').val();
        var searchRadius = $shipping.find('.field-ap-radius').val();
        var searchUnits = $shipping.find('.field-ap-radius').data('units');

        var url = $('.access-point-toggle').attr('data-url') + '?latitude=' + searchlat + '&longitude=' + searchlng + '&countryCode=' + countryCode + '&searchRadius=' + searchRadius + '&searchUnits=' + searchUnits;

        if ($shipping.find('.access-points-list').is(':visible')) {
            $shipping.find('.access-points-loader').show();
        } else {
            $shipping.find('.access-points-list-first').show();
            $shipping.find('.access-points-loader').show();
        }

        $.ajax({
            type: 'get',
            url: url,
            dataType: 'html'
        }).always(function () {
            $shipping.find('.access-points-list-first').hide();
            $shipping.find('.access-points-loader').hide();
        }).done(function (html) {
            $shipping.find('.access-points-no-results').hide();
            $shipping.find('.access-points-results').show();
            $shipping.find('.access-points-list-header').show();
            $shipping.find('.access-points-list').show();
            $shipping.find('.access-points-locations').html(html);

            updateAccessPointsScroller();
            updateAccessPointsMap(searchlat, searchlng);
        }).fail(function () {
            var $shippingForm = $('.shipping-form');
            var shippingHelpers = require('./shipping');
            shippingHelpers.methods.updateShippingMethodList($shippingForm);

            $shipping.find('.access-points-no-results').show();
            $shipping.find('.access-points-results').hide();
            $shipping.find('.access-points-list-header').hide();
            $shipping.find('.access-points-list').show();
        });
    };

    if (lat && lng) {
        continueSearch(lat, lng);
    } else {
        var address = $.trim($input.val());

        if (address.length > 0) {
            // Try to resolve this with geocoder.
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                address: address,
                componentRestrictions: {
                    country: $('#shippingCountry').val()
                }
            }, function (results, status) {
                if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
                    var place = results[0];

                    if (place.formatted_address && place.geometry && place.geometry.location) {
                        if (!$input.is(':focus')) {
                            $input.val(place.formatted_address);
                        }

                        $input.data('lat', place.geometry.location.lat()).data('lng', place.geometry.location.lng());

                        continueSearch(place.geometry.location.lat(), place.geometry.location.lng());
                    }
                }
            });
        }
    }
};

/**
 * Display shipping method when access point is active.
 */
var displayShippingMethod = function () {
    $('.shipping-type-regular').find('input[data-shippingtype="access-point"]').parent().remove();
    $('.shipping-type-regular').find('input[data-shippingtype="boss"]').parent().remove();
    $('.shipping-type-access-point').find('input[data-shippingtype="regular"]').parent().remove();
    $('.shipping-type-access-point').find('input[data-shippingtype="boss"]').parent().remove();
};

/**
 * update scroll bar.
 */
var updateAccessPointsScroller = function () {
    // Initialize swiper.
    if (apSwiper) {
        if (apSwiper.destroy) {
            apSwiper.destroy();

            apSwiper = null;
        }

        $shipping.find('.access-points-scrollbar').empty();
    }

    /* if ($('html').is('.compact-menu')) {
        return;
    }

    apSwiper = new window.Swiper($shipping.find('.access-points-locations .swiper-container').get(0), {
        mode: 'vertical',
        momentumBounce: false,
        scrollContainer: true,
        mousewheelControl: true,
        mousewheelControlForceToAxis: true,
        scrollbar: {
            container: $shipping.find('.access-points-scrollbar').get(0),
            draggable: true,
            hide: false,
            snapOnRelease: true
        }
    }); */
};

/**
 * Select AP location and populate the address.
 * @param {string} id - id
 */
var selectAccessPointLocation = function (id) {
    var $tile = $shipping.find('.ap-tile[data-location-id="' + id + '"]');

    $shipping.find('.ap-tile-select input').prop('checked', null);
    $tile.find('input').prop('checked', 'checked');

    // Update marker image.
    if (apMap) {
        apMarkers.forEach(function (marker) {
            var matchLocationId = (marker.locationId === id);

            if (matchLocationId) {
                setMarkerIcon(marker, marker.iconSelected);

                apMap.panTo(marker.position);
            } else {
                setMarkerIcon(marker, marker.iconNormal);
            }
        });
    }

    $shipping.find('.field-access-point-id').val(id);
    $shipping.find('.field-access-point-data').val(JSON.stringify({
        LocationId: $tile.data('location-id'),
        PublicAccessPointID: $tile.data('ap-id'),
        Latitude: $tile.data('lat'),
        Longitude: $tile.data('lng'),
        Name: $tile.data('name'),
        Address: $tile.data('address'),
        City: $tile.data('city'),
        Zip: $tile.data('zip'),
        State: $tile.data('state'),
        Country: $tile.data('country'),
        HoursOfOperation: $tile.data('hours'),
        PhoneNumber: $tile.data('phone'),
        Distance: $tile.data('distance'),
        UnitOfMeasurement: $tile.data('units')
    }));

    if ($tile.data('country')) {
        $shipping.find('.shippingCountry').val($tile.data('country'));
    }

    if ($tile.data('state')) {
        // state is not available in UK
        // $shipping.find('.').val($tile.data('state'))
    }

    if ($tile.data('name')) {
        $shipping.find('.shippingAddressOne').val($tile.data('name').substring(0, 30));

        if ($tile.data('address')) {
            $shipping.find('.shippingAddressTwo').val($tile.data('address').substring(0, 30));
        } else {
            $shipping.find('.shippingAddressTwo').val('');
        }
    } else if ($tile.data('address')) {
        $shipping.find('.shippingAddressOne').val($tile.data('address').substring(0, 30));
        $shipping.find('.shippingAddressTwo').val('');
    }

    if ($tile.data('zip')) {
        $shipping.find('.shippingZipCode').val($tile.data('zip'));
    }
    if ($tile.data('city')) {
        $shipping.find('.shippingAddressCity').val($tile.data('city'));
    }

    var $shippingForm = $('.shipping-form');
    var shippingHelpers = require('./shipping');
    shippingHelpers.methods.updateShippingMethodList($shippingForm);
};

/**
 * Find current position
 * @param {string} position - position
 */
var showPosition = function (position) {
    if (position.coords) {
        var place = {
            formatted_address: $(searchAddress).data(attrCurrentLocation),
            geometry: {
                location: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
            }
        };
        selectAccessPointAddress(place);
    }
};

/**
 * loding address
 * @param {string} key - key
 */
var loadAddress = function (key) {
    if (key === 'CURRENT_LOCATION') {
        findCurrentPosition();
    } else {
        var $input = $shipping.find(searchAddress);
        $input.data('lat', '').data('lng', '');
        searchForAccessPoint();
    }
};

/**
 * Update access point Map
 * @param {string} lat - latitude
 * @param {string} lng - longitude
 * @param {option} options - option
 */
var updateAccessPointsMap = function (lat, lng, options) {
    apLastMapResults = {
        lat: lat,
        lng: lng,
        options: options,
        visible: !$('html').is('.compact-menu')
    };

    if (!apLastMapResults.visible) {
        return;
    }

    // Adjust map to fit the canvas since it may be just now becoming visible.
    var latlng = new google.maps.LatLng(lat, lng);

    // http://jeffjason.com/2011/12/google-maps-radius-to-zoom/
    // Radius is in miles.
    var searchRadius = $shipping.find('.field-ap-radius').val();
    if ($shipping.find('.field-ap-radius').data('units') === 'KM') {
        searchRadius /= 1.60934;
    }
    var zoom = Math.round(14 - Math.log(searchRadius) / Math.LN2);

    if (apMap) {
        google.maps.event.trigger(apMap, 'resize');

        apMap.setCenter(latlng);

        apMap.setZoom(zoom);
    } else {
        var mapOptions = {
            zoom: zoom,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };

        // Wire up map.
        apMap = new google.maps.Map($shipping.find('.access-points-map').get(0), mapOptions);
    }

    // Create new markers.
    clearMarkers();

    var safe = function (v) {
        return $('<div></div>').text(v).html();
    };

    $shipping.find('.ap-tile').each(function () {
        var $tile = $(this);

        var shippinglatlng = new google.maps.LatLng($tile.data('lat'), $tile.data('lng'));

        var address = [$tile.data('address'), $tile.data('city'), $tile.data('state'), $tile.data('zip'), $tile.data('country')];

        var content = [
            '<div class="ap-location-marker">',
            '<h3>',
            safe($tile.data('name')),
            '</h3>',
            '<p>',
            safe(address),
            '</p>'
        ];

        if ($tile.data('hours')) {
            content.push('<p>', safe($tile.data('hours')), '</p>');
        }
        if ($tile.data('phone')) {
            content.push('<p>', safe($tile.data('phone')), '</p>');
        }
        if ($tile.data('distance')) {
            content.push('<p class="distance">', safe($tile.data('distance')), safe($tile.data('units')), '</p>');
        }

        content.push('<p><button class="button primary compact-small ap-tile-select-map" data-location-id="', $tile.data('location-id'), '"><span>', 'Select', '</span></button></p>');

        content.push('</div>');

        var marker = new google.maps.Marker({
            map: apMap,
            position: shippinglatlng,
            title: $tile.data('name'),
            icon: {
                url: options && options.useSelectedIcon ? $tile.data('image-selected') : $tile.data('image'),
                anchor: new google.maps.Point(4, 34)
            },
            html: content.join(''),
            locationId: $tile.data('location-id'),
            iconNormal: $tile.data('image'),
            iconSelected: $tile.data('image-selected')
        });

        addMarker(marker);
        setMarkerIcon(marker, marker.iconNormal);

        var info = new google.maps.InfoWindow({
            content: ''
        });

        google.maps.event.addListener(marker, 'click', function () {
            if (apCurrentInfo) {
                apCurrentInfo.close();
            }

            info.setContent(this.html);
            info.open(apMap, this);

            apCurrentInfo = info;

            // Scroll to position.
            /* if (apSwiper) {
                $shipping.find('.ap-tile').each(function () {
                    var $aptile = $(this);

                    if ($aptile.data('location-id') === marker.locationId) {
                        var top = $aptile.position().top;
                        var parentTop = $aptile.parents('.access-points-locations').scrollTop();

                        $('.access-points-locations').animate({
                            scrollTop: parentTop + top
                        });

                    }

                });
            } */
        });
    });

    if (!options || options.onlyLocation !== true) {
        var marker = new google.maps.Marker({
            map: apMap,
            position: latlng
        });

        addMarker(marker);
    }
};

/**
 * Figures out latitude/longitude of the entered location.
 * @param {string} place - Place
 */
var selectAccessPointAddress = function (place) {
    var $input = $shipping.find(searchAddress);
    if (place && place.formatted_address && place.geometry && place.geometry.location) {
        $input.data('lat', place.geometry.location.lat).data('lng', place.geometry.location.lng);
        if (!$input.is(':focus') || place.formatted_address !== $input.data(attrCurrentLocation)) {
            $input.val(place.formatted_address);
        }
        searchForAccessPoint();
    }
};

/**
 * Find current position
 */
var findCurrentPosition = function () {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
    }
    $(searchAddress).data('with-current-location', true);
};

module.exports = {
    methods: {
        displayShippingMethod: displayShippingMethod
    },
    initUpsAccessPoints: function () {
        var checkoutMain = $('#checkout-main');
        var checkoutStage = checkoutMain.attr('data-checkout-stage');

        shippingAddressUpdate.isShippingRegular();

        if ($shipping.is('.shipping-type-access-point') && checkoutStage === 'shipping') {
            shippingAddressUpdate.selectShippingType('access-point');
            shippingAddressUpdate.clearForm();
            findCurrentPosition();
        }

        if ($shipping.find('.access-point-toggle').length <= 0) {
            return;
        }

        var $accessPointID = $('.field-access-point-id');
        var $accessPointData = $('.field-access-point-data');

        var input = document.getElementById('shippingAddressAccessPoint');
        if (typeof google !== 'object') {
            return;
        }
        $('#shippingAddressAccessPoint').focus(function () {
            $(this).attr('autocomplete', 'new-password');
        });
        var countryRestrict = '';
        var shippingCountryValue = $('#shippingCountry').val();
        if (shippingCountryValue) {
            var countryValue = shippingCountryValue.toLowerCase();
            countryRestrict = [countryValue];
        } else if ($('input[name$=countryListShipping]').val()) {
            countryRestrict = $('input[name$=countryListShipping]').val().split(', ');
        }

        $(searchAddress).on('focusin', function () {
            var val = $(this).val();
            if (val === $(this).data(attrCurrentLocation) || val === 'Finding Your Location...') {
                $(this).val('');
            }
        });

        $(searchAddress).on('focusout', function () {
            var val = $(this).val();
            if (val === '' && $(this).data('with-current-location')) {
                $(this).val($(this).data(attrCurrentLocation));
            }
        });

        // Create the autocomplete object, restricting the search to geographical
        // location types.
        var options = {
            types: ['geocode'],
            componentRestrictions: {
                country: countryRestrict
            }
        };
        var autoComplete = new google.maps.places.Autocomplete(input, options);
        autoComplete.addListener('place_changed', function () {
            loadAddress($('#shippingAddressAccessPoint').val());
        });

        // Regular shipping event
        shippingAddressUpdate.addEventListeners();

        $shipping.on('click', '#ap-shipping-type-selector-ap', function (e) {
            e.stopImmediatePropagation();
            shippingAddressUpdate.clearForm();
            shippingAddressUpdate.selectShippingType('access-point');
            findCurrentPosition();
            $accessPointID.val('');
            $accessPointData.val('');
        });

        $shipping.on('click', '.action-ap-search', function (e) {
            e.preventDefault();
            searchForAccessPoint();
        });

        $shipping.on('change', '.ap-tile-select input', function (e) {
            selectAccessPointLocation($(e.target).closest('.ap-tile').data('location-id'));
        });

        $shipping.on('click', '.ap-tile-select-map', function (e) {
            e.preventDefault();
            selectAccessPointLocation($(this).data('location-id'));
        });

        // Highlight marker on hover.
        $shipping.on('mouseenter', '.ap-tile', function () {
            var locationId = $(this).data('location-id');
            apMarkers.forEach(function (marker) {
                if (marker.locationId === locationId) {
                    setMarkerIcon(marker, marker.iconSelected);
                }
            });
        });

        $shipping.on('mouseleave', '.ap-tile', function () {
            var locationId = $(this).data('location-id');
            apMarkers.forEach(function (marker) {
                if (marker.locationId === locationId) {
                    setMarkerIcon(marker, marker.selected ? marker.iconSelected : marker.iconNormal);
                }
            });
        });
    }
};
